/**
* Parallax backgrounds
* Uses Greensock and ScrollMagic
*/

let ScrollMagic = require('scrollmagic');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
require('gsap/src/uncompressed/plugins/ScrollToPlugin.js');
require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators');

import $ from 'jquery';

const $el = {
	bgImagesContainer: $('.c-parallax-background-container')
};

// Init ScrollMagic controller
const controller = new ScrollMagic.Controller();

export default function init() {
	bgImagesParallax();
}

function bgImagesParallax() {
	if (!$el.bgImagesContainer.length) return;
	var tween = new TimelineMax ()
	.add([
		TweenMax.to('#simple-parallax-bg-1', 1, {backgroundPosition: '50% -100%', ease: Linear.easeNone}),
		TweenMax.to('#simple-parallax-bg-2', 1, {backgroundPosition: '50% -205%', ease: Linear.easeNone}),
		TweenMax.to('#simple-parallax-bg-3', 1, {backgroundPosition: '50% -300%', ease: Linear.easeNone})
	]);
	
	// build scene
	var scene = new ScrollMagic.Scene({
		triggerElement: '.c-parallax-background-container',
		triggerHook: 'onEnter',

		duration: 2000
	})
	.setTween(tween)
	// .addIndicators()
	.addTo(controller);
}